import {billingOutputLabel} from "./billing-decision-display";
import type {BillingDecisionTrace} from "./ticket-cost-types";

const sourceLabels: Record<string, string> = {location: "From the location", override: "From an override",
  "suppressed by AFE override": "Suppressed by the expenditure code override"};

/** Separate strips for each output keep split coding's component sources independent. */
export const BillingAfeSources = ({trace}: {trace: BillingDecisionTrace}) => {
  const outputs = trace.steps.filter(step => step.code === "BILLING_LOCATION");
  if (!outputs.length) return <p className="text-sm text-[var(--ots-text-muted)]">No billing location was selected, so no expenditure code was applied.</p>;
  return <div aria-label="Expenditure code component sources" className="space-y-4">
    {outputs.map((output, index) => <section key={index} aria-label={billingOutputLabel(trace, output)}>
      <h4 className="mb-2 text-sm font-semibold">{billingOutputLabel(trace, output)}</h4>
      <dl className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        {([['prefix', 'Prefix'], ['afe', 'Expenditure code'], ['suffix', 'Suffix']] as const).map(([key, label]) => {
          const source = output.values[`${key}Source`];
          const value = output.values[key];
          const coded = trace.steps.some(step => step.code === "CODED_LOCATION" && step.entityId === output.entityId &&
            step.values[key] != null && step.values[key] === value);
          const stageOverride = trace.steps.some(step => step.code === "STAGE_AFE" && step.entityId === output.entityId);
          const stageName = trace.intervals.find(interval => interval.wellId === output.entityId && interval.outcome === "selected")?.stageName;
          const sourceLabel = source === "override" && coded ? "From the ticket code"
            : source === "override" && stageOverride ? `From the ${stageName ?? "selected"} stage override`
            : sourceLabels[source] ?? source ?? "Source not provided";
          return <div key={key} className="rounded-lg border border-[var(--ots-outline-variant)] bg-[var(--ots-surface-variant)] p-3">
            <dt className="text-xs text-[var(--ots-text-muted)]">{label}</dt>
            <dd className="mt-1 break-all font-mono text-sm font-semibold">{value || (source === "suppressed by AFE override" ? "Suppressed" : "Not set")}</dd>
            <dd className="mt-2 text-xs text-[var(--ots-text-muted)]">{sourceLabel}</dd>
          </div>;
        })}
      </dl>
    </section>)}
  </div>;
};
